/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 11:27:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-09-18 08:55:04
 */
export default {
  examPlanList: '/yangtse/admin/examPlan/getList',
  examPlanRemove: '/yangtse/admin/examPlan/remove',
  examPlanGetById: '/yangtse/admin/examPlan/getById',
  examPlanUpdate: '/yangtse/admin/examPlan/update',
  examPlanPublish: '/yangtse/admin/examPlan/publish',
  examPlanUnPublish: '/yangtse/admin/examPlan/unPublish',
  examPlanStop: '/yangtse/admin/examPlan/endTest',
  examPlanExport: '/yangtse/admin/examPlan/exportGetList',
  filterJobLevel: '/yangtse/filter/job/level',
  filterWorkType: '/yangtse/filter/work/type',
  addExamPlan: '/yangtse/admin/examPlan/create',
  examPaperList: '/yangtse/admin/exam/paper/model/page',
  examPaperExport: '/yangtse/admin/exam/paper/model/export',
  examPaperRemove: '/yangtse/admin/exam/paper/model/paper/remove',
  examPaperCreate: '/yangtse/admin/exam/paper/model/paper/create',
  examPaperEdit: '/yangtse/admin/exam/paper/model/paper/edit',
  examPaperStatusEdit: '/yangtse/admin/exam/paper/model/status/edit',
  examPaperDetail: '/yangtse/admin/exam/paper/model/detail',
  examPaperTempDownload: '/yangtse/admin/exam/paper/model/question/download/template',
  examPaperQuestionImport: '/yangtse/admin/exam/paper/model/question/import',
  examPaperRelatedPlan: '/yangtse/admin/exam/paper/model/related/plan',
  examSubjectCreate: '/yangtse/admin/examSubject/create',
  examSubjectGetList: '/yangtse/admin/examSubject/getList',
  examSubjectBindPaper: '/yangtse/admin/examSubject/bidingPaperId',
  examSubjectDel: '/yangtse/admin/examSubject/del',
  examUserTempDownload: '/yangtse/examUserModel/template/download',
  examUserImport: '/yangtse/examUserModel/import',
  examUserList: '/yangtse/examUserModel/getPlanExamUser',
  examUserDel: '/yangtse/examUserModel/delPlanExamUser',
  examUserExport: '/yangtse/examUserModel/exportPlanExamUser',
  filterAdminList: '/yangtse/filter/admin/list',
  teacherList: '/yangtse/admin/examPlan/plan/invigilation/teacher/list',
  userTeacherList: '/yangtse/admin/examPlan/invigilation/teacher/list',
  userTeacherDelete: '/yangtse/admin/examPlan/delete/invigilation/teacher',
  userTeacherAdd: '/yangtse/admin/examPlan/add/invigilation/teacher',
  paperQuestionList: '/yangtse/admin/exam/paper/model/paper/question/list',
  paperQuestionSort: '/yangtse/admin/exam/paper/model/paper/question/sort',
  paperQuestionDetail: '/yangtse/admin/exam/paper/model/paper/question/detail',
  paperQuestionCreate: '/yangtse/admin/exam/paper/model/question/create/simple',
  paperQuestionEdit: '/yangtse/admin/exam/paper/model/paper/question/edit',
  paperQuestionRemove: '/yangtse/admin/exam/paper/model/paper/question/remove',
  paperQuestionImport: '/yangtse/admin/exam/paper/model/question/import',
  examresultPlanDropDown: '/yangtse/admin/examPlan/dropDown',
  examresultSubjectDropDown: '/yangtse/admin/examSubject/dropDown',
  examRecordPage: '/yangtse/admin/exam/record/get/recordPage',
  examRecordExport: '/yangtse/admin/exam/record/get/export',
  examMarkPage: '/yangtse/identify/exam/subject/mark/page',
  examMarkExport: '/yangtse/identify/exam/subject/mark/export',
  examRecordInfo: '/yangtse/admin/exam/record/detail/user',
  examMarkUserList: '/yangtse/identify/exam/subject/mark/exam/user/list',
  examMarkCheckDetail: '/yangtse/identify/exam/subject/mark/exam/user/record/detail',
  submitMarkscore: '/yangtse/identify/exam/subject/mark/scoring',
  changeQuestionName: '/yangtse/exam/question/edit',
  changeQuestionAnwser: '/yangtse/haha2',
  changeQuestionScore: '/yangtse/haha3',
  testPaperData: '/yangtse/identify/exam/test',
  examPlanPublishRemove: '/yangtse/admin/examPlan/publish/remove',
  examPlanSubjectDetail: '/yangtse/admin/examSubject/detail',
  examPlanSubJectEdit: '/yangtse/admin/examSubject/edit',

  examCheckCommentSubmit: '/yangtse/identify/exam/subject/mark/comment',
  examPhotoAddRecord: '/yangtse/admin/examPhoto/add/record',

  subjectMarkingTeachers: '/yangtse/user/marking/subject/teachers',
  subjectMarkingBind: '/yangtse/user/marking/subject/bind',
  subjectMarkingEdit: '/yangtse/user/marking/subject/edit',
  subjectMarkingQuestions: '/yangtse/user/marking/subject/question/answer/count',
  markingVideoList: '/yangtse/marking/video/list',
  markingVideoPage: '/yangtse/marking/video/page',
  markingVideoAdd: '/yangtse/marking/video/add',
  markingVideoEdit: '/yangtse/marking/video/edit',
  markingVideoDetail: '/yangtse/marking/video/detail',

  questionStorePage: '/yangtse/manage/question/store/page/new',
  questionStoreCreate: '/yangtse/manage/question/store/create',
  questionStoreRename: '/yangtse/manage/question/store/rename',
  questionStoreImport: '/yangtse/manage/question/store/import/excel',
  questionStoreTempDownload: '/yangtse/manage/question/store/download/template',
  questionStoreDetailPage: '/yangtse/manage/question/store/detail/page',
  questionStoreDeleteQuestion: '/yangtse/manage/question/store/delete/question',
  paperImportFromStore: '/yangtse/admin/exam/paper/model/question/import/store',
  paperGetQuestionConfig: '/yangtse/admin/exam/paper/model/get/question/config',
  paperEditQuestionConfig: '/yangtse/admin/exam/paper/model/edit/question/config',

  examRusltExport: '/yangtse/admin/exam/record/subject/record/detail/export',

  questionStoreList: '/yangtse/manage/question/store/question/list',
  questionListSort: '/yangtse/manage/question/store/store/question/sort',
  questionDetail: '/yangtse/manage/question/store/question/detail',
  questionCreate: '/yangtse/manage/question/store/question/create/simple',
  questionEdit: '/yangtse/manage/question/store/store/question/edit',
  questionRemove: '/yangtse/manage/question/store/delete/question',
  questionStoreDelete: '/yangtse/manage/question/store/delete',
  storeQuestionExport: '/yangtse/manage/question/store/question/export',
}
